


























































import { defineComponent, computed, ref, watch, getCurrentInstance, toRef } from '@vue/composition-api';
import { ErrorCircleIcon, UserIcon } from 'tdesign-icons-vue';
import guideStepHandler from '@/renderer/components/GuideAndHelp/composition/guideStepHandler';
import ConstantConfig from '@/renderer/scripts/utils/ConstantConfig';
import i18n, { i18n_t } from '@/locales/i18n';
import createCollaborationHandler from '../compositions/createCollaborationHandler';
export default defineComponent({
  name: 'MobileCreateCollaboration',
  components: {
    ErrorCircleIcon,
    UserIcon,
  },
  props: {
    show: {
      required: true,
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    importPath: {
      type: String,
      default: '',
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const store = vm.$store;
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const { groupNameMaxLength } = ConstantConfig;
    const { methods: guideStepMethods } = guideStepHandler();

    const { formData, createLoading, rules, methods: createMethods } = createCollaborationHandler();
    const moreUsersName = computed(() => {
      let names = '';
      if (formData.users.length > 5) {
        const users = formData.users.slice(5);
        names = users.map(user => `${user.nickname}(${user.phoneNumber || i18n_t('暂未绑定')})`).join('、');
      }
      return names;
    });
    const disabledSubmit = computed(() => !formData.name);
    const defaultRoleId = computed(() => vm.$store.getters.defaultRoleId);
    const methods = {
      async onSubmit(type?: 'invite' | string) {
        // 如果正在导入中｜正在创建中直接return，避免重复创建
        if (props.loading || createLoading.value) return;
        const validate = await (context.refs.form as any).validate();
        if (typeof validate === 'boolean' && validate) {
          createMethods.onCreate().then(async code => {
            if (code !== -1) {
              // 查看新手引导是否有对应数据，如果没有，对其进行对应新建协作的更新
              guideStepMethods.monitoringStepsDone('collaborationSpace', 0);
              // methods.onClose(); // 导入成功后，手动赋值关闭，避免提前清空文件路径
              context.emit('success', code, type);
            }
          });
        }
      },
      onClose() {
        innerShow.value = false;
        context.emit('showImport', 'create', false); // 关闭创建时，清空已有的文件路径
      },

      showImportDialog() {
        context.emit('showImport', 'import', true);
      },
    };
    watch(innerShow, val => {
      if (val) {
        createMethods.initData();
      }
    });
    return {
      rules,
      disabledSubmit,
      defaultRoleId,
      innerShow,
      formData,
      moreUsersName,
      groupNameMaxLength,
      ...methods,
    };
  },
});
